import Vue from "modules/vue_twemoji";
import QuestUsernameForm from "components/quest-username-form";

document.querySelectorAll(".js-quest-username-form").forEach($el => {
  new Vue({
    el: $el,
    render: h => h(QuestUsernameForm, {
      props: {
      }
    })
  });
});
